import * as React from 'react'
import { Callout } from '@radix-ui/themes'
import { cn } from '../../lib/utils'

export interface AlertProps {
  variant?: 'error' | 'warning' | 'info' | 'success'
  children: React.ReactNode
  className?: string
}

export const Alert = ({ 
  variant = 'error', 
  children, 
  className 
}: AlertProps) => {
  const variantConfig = {
    error: {
      color: 'red' as const,
    },
    warning: {
      color: 'amber' as const,
    },
    info: {
      color: 'blue' as const,
    },
    success: {
      color: 'green' as const,
    },
  }

  const config = variantConfig[variant]

  return (
    <Callout.Root
      color={config.color}
      className={cn("!py-2.5 !px-3", className)}
    >
      <Callout.Text>
        {children}
      </Callout.Text>
    </Callout.Root>
  )
} 